import { createFileRoute } from "@tanstack/react-router";
import BackCameraAIFlow from "@/features/assessments/pages/back-camera-ai/BackCameraAiFlow";

export const Route = createFileRoute("/$locale/$partner/_camera/back-camera-ai")({
	component: BackCameraAIFlow,
});
